// Full-body transition loader shown when an action switch is in flight.
//
// Flat circular line spinner — brand-tinted track that rotates. Sits in
// place of list/kanban/form while the action plan is fetching OR records
// is still showing the previous slug's placeholder rows. Pure CSS, no
// lucide / SVG dependency so the animation stays crisp at any zoom.
export function ViewLoader({ label = "Loading…" }: { label?: string }) {
    return (
        <div className="view-loader" role="status" aria-live="polite">
            <span className="view-loader__spinner" aria-hidden="true" />
            <p className="view-loader__label">{label}</p>
        </div>
    );
}
